import React from "react";
import { DownloadIcon, PrinterIcon, RepeatIcon, SmartphoneIcon } from "lucide-react";
import { usageOptions } from "../data/landing";
const icons = {
  download: DownloadIcon,
  printer: PrinterIcon,
  repeat: RepeatIcon,
  smartphone: SmartphoneIcon
};
export function UsageSection() {
  return <section className="mx-auto max-w-6xl px-5 py-16 md:py-20" data-id="element-153" data-mp="370gw5fglvxe1">
      <div className="grid gap-10 md:grid-cols-2 md:gap-16" data-id="element-154" data-mp="3733bi19qnh6t">
        <div data-id="element-155" data-mp="2jc7dgmeovpr4">
          <h2 className="font-display text-2xl font-bold text-ink md:text-3xl" data-id="element-156" data-mp="2jbxw1n7pmqx1">Úsalo como prefieras</h2>
          <p className="mt-3 text-lg text-muted" data-id="element-157" data-mp="2ee5wc70tq0ia">
            Todo el contenido de RecursoPDF se entrega en formato digital. Puedes:
          </p>
          <ul className="mt-6 space-y-4" data-id="element-158" data-mp="2o9zhufwit4c7">
            {usageOptions.map(u => {
            const Icon = icons[u.icon];
            return <li key={u.text} className="flex items-start gap-3 text-ink" data-id="element-159" data-mp="7k24jvmsmofd">
                  <Icon className="mt-0.5 h-5 w-5 shrink-0 text-plum" aria-hidden="true" data-id="element-160" data-mp="3ji5unmkncr4" />
                  {u.text}
                </li>;
          })}
          </ul>
          <p className="mt-6 font-bold text-ink" data-id="element-161" data-mp="11q6mq1u1euzv">
            Sin envíos físicos. <span className="text-muted" data-id="element-162" data-mp="15sjqwlt4ykuj">Sin esperar que llegue un paquete.</span>
          </p>
        </div>

        <div className="space-y-10 md:border-l md:border-line md:pl-16" data-id="element-163" data-mp="1are8xlja45dl">
          <div data-id="element-164" data-mp="1apa8jdkl9oi2">
            <h2 className="font-display text-2xl font-bold text-ink" data-id="element-165" data-mp="e1nflpmq4o9d">¿Tengo que saber dibujar?</h2>
            <p className="mt-2 font-display text-xl font-bold text-plum" data-id="element-166" data-mp="i2ph6d445cei">Para nada.</p>
            <p className="mt-3 leading-relaxed text-muted" data-id="element-167" data-mp="i0mk594jmj0a">
              Este material no busca enseñarte dibujo ni evaluar tu capacidad artística. Puedes completar las
              actividades utilizando líneas, palabras, colores, símbolos, garabatos o formas simples.
            </p>
            <p className="mt-3 leading-relaxed text-muted" data-id="element-168" data-mp="3qgpp3749ttkx">
              No existe una manera “correcta” de completar las ilustraciones. La idea es que puedas hacerlas tuyas.
            </p>
          </div>

          <div data-id="element-169" data-mp="12l2498569xcs">
            <h2 className="font-display text-2xl font-bold text-ink" data-id="element-170" data-mp="xok0oblkw521">No tienes que hacer todo de una vez</h2>
            <p className="mt-3 leading-relaxed text-muted" data-id="element-171" data-mp="1bg8bmbk3cnhf">
              Más de 50 técnicas pueden parecer muchas. Y justamente esa es la idea. No necesitas completar el MegaPack
              de principio a fin como si fuera un curso. Puedes abrirlo y preguntarte:
            </p>
            <p className="my-4 border-l-4 border-sun pl-4 font-display text-xl font-bold text-plum" data-id="element-172" data-mp="epfy9lojl9jc">
              “¿Qué necesito hoy?”
            </p>
            <p className="leading-relaxed text-muted" data-id="element-173" data-mp="sqsb3o8eov10">
              Quizás quieras una actividad para bajar revoluciones. Otro día quieras entender mejor una emoción. O
              simplemente tengas ganas de dibujar durante diez minutos.
            </p>
            <p className="mt-3 font-bold text-ink" data-id="element-174" data-mp="1z5sxb27mpyue">Elige una práctica y empieza por ahí.</p>
          </div>
        </div>
      </div>
    </section>;
}